function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  fill: "#0E2F52",
  cx: 130.143,
  cy: 282.699,
  rx: 124.896,
  ry: 2.538
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D09460",
  d: "M41.023,281.254c-0.869-2.584-2.496-5.167-2.501-7.753 c-0.135-79.052-0.112-158.104-0.106-237.157c0.001-6.465,2.315-8.762,8.802-8.752c12.854,0.019,25.709,0.066,38.562,0.101 c-0.231,3.69-0.46,7.382-0.691,11.072c-12.79-0.001-25.58-0.001-38.745-0.001c0.646,72.65-1.415,144.656-6.628,216.768 c2.421,0.188,4.516,0.351,6.611,0.514c-2.49,0.446-2.217,2.494-1.736,3.931c0.272,0.815,1.955,1.565,3.05,1.636 c9.315,0.608,18.644,0.999,27.962,1.558c17.507,1.05,35.008,2.188,52.514,3.254c8.645,0.527,17.296,0.94,25.939,1.466 c16.481,1.003,32.96,2.049,49.658,3.092c0.113-1.083,0.276-1.948,0.284-2.815c0.269-30.079,0.528-60.158,0.75-90.236 c0.009-1.192-0.374-2.388-0.575-3.582c0.209-6.996,0.416-13.991,0.625-20.987c0.192-0.737,0.55-1.474,0.553-2.211 c0.031-9.2,0.011-18.4,0.004-27.601c-0.09-0.207-0.07-0.403,0.057-0.588c0.223-0.832,0.604-1.657,0.641-2.497 c0.239-5.396,0.452-10.794,0.582-16.194c0.484-20.152,0.945-40.305,1.387-60.458c0.104-4.734,0.051-4.735-4.648-4.786 c-12.477-0.086-24.953-0.171-37.43-0.257l-0.177-0.119l-0.186,0.116c-0.521,0.002-1.042,0.004-1.563,0.006 c-0.63-0.159-1.26-0.319-1.89-0.478c-0.472-3.526-0.943-7.052-1.414-10.577c15.876-0.006,31.751-0.012,47.624-0.018 c3.83,1.247,5.31,3.778,5.305,7.895c-0.084,79.51-0.08,159.021-0.012,238.532c0.003,3.991-1.296,6.746-5.02,8.253 c-0.787,0.042-1.575,0.124-2.363,0.124c-53.108,0.005-106.218,0.017-159.327-0.049C44.954,282.45,42.989,281.671,41.023,281.254z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#B4D6D7",
  d: "M85.088,38.766c0.23-3.691,0.459-7.382,0.69-11.073 c3.289-1.06,6.576-2.12,10.565-3.406c0.006-0.078,0.09-1.145,0.156-2.212c0.33-5.393,3.905-9.221,9.227-9.289 c10.798-0.139,21.6-0.157,32.396,0.031c5.82,0.102,9.008,3.646,9.192,9.455c0.028,0.886,0.097,1.771,0.153,2.759 c3.152,0.419,6.203,0.825,9.254,1.229c0.658,1.926,1.587,3.811,1.903,5.792c0.345,2.166,0.124,4.422,0.15,6.639 c-0.472,4.664-1.701,5.804-6.415,5.807c-19.906,0.013-39.812,0.01-59.717,0.009C86.701,44.508,86.548,44.385,85.088,38.766z  M103.851,29.549c-3.268,0-6.543-0.124-9.799,0.075c-0.992,0.061-1.93,1.011-2.892,1.554c0.917,0.585,1.824,1.657,2.754,1.678 c6.646,0.146,13.298,0.146,19.943-0.002c0.917-0.021,1.809-1.114,2.712-1.71c-0.972-0.532-1.919-1.462-2.918-1.522 C110.395,29.425,107.12,29.548,103.851,29.549z M133.464,25.244c0.443-2.62-1.205-3.021-3.004-3.037 c-5.631-0.052-11.265-0.134-16.888,0.077c-1.268,0.047-2.491,1.232-3.736,1.893c0.167,0.355,0.334,0.711,0.5,1.067 C118.03,25.244,125.722,25.244,133.464,25.244z M123.331,33.768c1.215-1.006,2.021-1.673,2.827-2.341 c-1.005-0.625-1.979-1.672-3.023-1.749c-0.919-0.067-1.916,0.953-2.879,1.492C121.146,31.922,122.037,32.674,123.331,33.768z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#7D5247",
  d: "M208.61,282.377c3.724-1.507,5.022-4.262,5.02-8.253 c-0.068-79.51-0.072-159.021,0.012-238.532c0.005-4.117-1.475-6.647-5.305-7.895c7.052-0.411,9.349,1.673,9.348,8.514 c-0.003,79.314,0.011,158.628-0.109,237.943c-0.003,2.393-1.401,4.783-2.148,7.175 C213.155,281.679,210.882,282.028,208.61,282.377z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#6F5576",
  d: "M158.776,38.691c-0.026-2.217,0.194-4.473-0.15-6.639 c-0.316-1.981-1.245-3.866-1.903-5.792c1.331,0.485,2.662,0.969,3.991,1.454c0.47,3.527,0.941,7.053,1.413,10.579 c-0.328,0.153-0.653,0.306-0.98,0.459C160.356,38.732,159.566,38.712,158.776,38.691z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#794C46",
  d: "M46.326,256.045c49.703,0.791,99.407,1.583,149.111,2.372 c1.113,0.018,2.227,0.002,4.213,0.002c1.512-28.121,3.018-56.094,4.521-84.071c0.201,1.193,0.584,2.389,0.575,3.581 c-0.222,30.078-0.481,60.158-0.75,90.236c-0.008,0.867-0.171,1.733-0.284,2.815c-16.698-1.043-33.177-2.088-49.658-3.092 c-8.644-0.526-17.295-0.938-25.939-1.466c-17.506-1.065-35.007-2.204-52.514-3.254c-9.318-0.559-18.646-0.95-27.962-1.558 c-1.095-0.071-2.777-0.821-3.05-1.636C44.109,258.539,43.835,256.492,46.326,256.045z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#7D5247",
  d: "M205.41,122.961c-0.68-27.979-1.359-55.957-2.039-83.936 c4.699,0.051,4.752,0.052,4.648,4.786c-0.441,20.153-0.902,40.306-1.387,60.458c-0.13,5.4-0.343,10.798-0.582,16.194 C206.013,121.304,205.632,122.129,205.41,122.961z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#E08E74",
  d: "M204.796,153.361c0.186-9.937,0.371-19.875,0.557-29.812 c0.007,9.2,0.027,18.4-0.004,27.601C205.346,151.887,204.989,152.624,204.796,153.361z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#B4D6D7",
  d: "M164.016,38.771c-0.956-0.006-1.912-0.011-2.869-0.018 c0.326-0.153,0.651-0.307,0.979-0.459C162.756,38.452,163.386,38.612,164.016,38.771z"
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#B4D6D7",
  points: "165.941,38.768 165.754,38.856 165.576,38.766  165.764,38.649  "
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D3F1FB",
  d: "M103.851,29.549c3.269,0,6.544-0.124,9.801,0.072 c0.999,0.06,1.946,0.99,2.918,1.522c-0.903,0.596-1.795,1.69-2.712,1.71c-6.646,0.148-13.297,0.148-19.943,0.002 c-0.93-0.021-1.837-1.093-2.754-1.678c0.962-0.543,1.899-1.494,2.892-1.554C97.308,29.425,100.583,29.549,103.851,29.549z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#3797A3",
  d: "M133.464,25.244c-7.742,0-15.435,0-23.128,0 c-0.166-0.355-0.333-0.711-0.5-1.067c1.245-0.661,2.469-1.846,3.736-1.893c5.623-0.211,11.257-0.129,16.888-0.077 C132.259,22.224,133.908,22.624,133.464,25.244z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D3F1FB",
  d: "M123.331,33.768c-1.294-1.094-2.185-1.845-3.075-2.598 c0.963-0.54,1.96-1.56,2.879-1.492c1.045,0.077,2.019,1.124,3.023,1.749C125.352,32.094,124.545,32.761,123.331,33.768z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FBFBFA",
  d: "M205.41,122.961c-0.68-27.979-1.359-55.957-2.039-83.936 c-12.477-0.086-24.953-0.171-37.43-0.257l-0.187,0.088c0,0-0.183-0.089-0.179-0.09c-0.518,0.001-1.039,0.003-1.56,0.005 c-0.956-0.006-1.912-0.011-2.869-0.018c-0.791-0.021-1.581-0.041-2.371-0.062c-0.472,4.664-1.701,5.804-6.415,5.807 c-19.906,0.013-39.812,0.01-59.717,0.009c-5.943,0-6.096-0.123-7.557-5.743c-12.79-0.001-25.58-0.001-38.745-0.001 c0.646,72.65-1.415,144.656-6.628,216.768c2.421,0.188,4.516,0.351,6.611,0.514c49.703,0.791,99.407,1.583,149.111,2.372 c1.113,0.018,2.227,0.002,4.213,0.002c1.512-28.121,3.018-56.094,4.521-84.071c0.209-6.997,0.416-13.992,0.625-20.988 c0.186-9.937,0.371-19.875,0.557-29.812C205.263,123.342,205.283,123.146,205.41,122.961z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#B4D6D7",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  d: " M89.125,102.344c0,2.471-2.004,4.474-4.474,4.474H62.074c-2.47,0-4.474-2.003-4.474-4.474v-22.99c0-2.471,2.004-4.474,4.474-4.474 h22.578c2.47,0,4.474,2.003,4.474,4.474V102.344z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#B4D6D7",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  d: " M89.125,143.304c0,2.471-2.004,4.474-4.474,4.474H62.074c-2.47,0-4.474-2.003-4.474-4.474v-22.99c0-2.471,2.004-4.474,4.474-4.474 h22.578c2.47,0,4.474,2.003,4.474,4.474V143.304z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#B4D6D7",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  d: " M89.125,184.406c0,2.471-2.004,4.474-4.474,4.474H62.074c-2.47,0-4.474-2.003-4.474-4.474v-22.99c0-2.471,2.004-4.474,4.474-4.474 h22.578c2.47,0,4.474,2.003,4.474,4.474V184.406z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#B4D6D7",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  d: " M89.125,225.251c0,2.471-2.004,4.474-4.474,4.474H62.074c-2.47,0-4.474-2.003-4.474-4.474v-22.99c0-2.471,2.004-4.474,4.474-4.474 h22.578c2.47,0,4.474,2.003,4.474,4.474V225.251z"
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#206FBC",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  points: " 63.332,88.699 71.999,95.602 93.332,74.879  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#206FBC",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  points: " 63.332,130.552 71.999,137.455 93.332,116.732  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#206FBC",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  points: " 63.332,170.975 71.999,177.877 93.332,157.155  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#206FBC",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  points: " 63.332,212.272 71.999,219.175 93.332,198.453  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M158.044,56.592c0,2.622-2.125,4.748-4.747,4.748h-57.39c-2.622,0-4.747-2.125-4.747-4.748l0,0 c0-2.622,2.125-4.748,4.747-4.748h57.39C155.919,51.845,158.044,53.97,158.044,56.592L158.044,56.592z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M183.612,81.662c0,1.155-0.937,2.091-2.092,2.091h-77.507c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h77.507C182.675,79.57,183.612,80.506,183.612,81.662L183.612,81.662z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M156.665,90.791c0,1.155-0.937,2.091-2.092,2.091h-50.504c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h50.504C155.728,88.699,156.665,89.636,156.665,90.791L156.665,90.791z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M169.61,99.786c0,1.155-0.937,2.091-2.092,2.091h-63.505c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h63.505C168.673,97.694,169.61,98.631,169.61,99.786L169.61,99.786z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M165.61,122.68c0,1.155-0.937,2.091-2.092,2.091h-59.505c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h59.505C164.673,120.588,165.61,121.524,165.61,122.68L165.61,122.68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M156.665,131.809c0,1.155-0.937,2.091-2.092,2.091h-50.504c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h50.504C155.728,129.717,156.665,130.654,156.665,131.809L156.665,131.809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M170.611,140.804c0,1.155-0.937,2.091-2.092,2.091h-64.506c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h64.506C169.674,138.712,170.611,139.649,170.611,140.804L170.611,140.804z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M165.61,163.781c0,1.155-0.937,2.091-2.092,2.091h-59.505c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h59.505C164.673,161.689,165.61,162.626,165.61,163.781L165.61,163.781z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M178.667,172.911c0,1.155-0.937,2.091-2.092,2.091h-72.507c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h72.507C177.731,170.819,178.667,171.755,178.667,172.911L178.667,172.911z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M133.607,181.906c0,1.155-0.937,2.091-2.092,2.091h-27.502c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h27.502C132.67,179.814,133.607,180.75,133.607,181.906L133.607,181.906z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M179.611,204.626c0,1.155-0.937,2.091-2.092,2.091h-73.506c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h73.506C178.674,202.535,179.611,203.471,179.611,204.626L179.611,204.626z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M165.666,213.756c0,1.155-0.937,2.091-2.092,2.091h-59.505c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h59.505C164.729,211.664,165.666,212.601,165.666,213.756L165.666,213.756z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4D6D7",
  d: "M176.611,222.751c0,1.155-0.937,2.091-2.092,2.091h-70.506c-1.155,0-2.092-0.937-2.092-2.091l0,0 c0-1.155,0.937-2.092,2.092-2.092h70.506C175.674,220.659,176.611,221.596,176.611,222.751L176.611,222.751z"
})));

var SvgPrinciples = function SvgPrinciples(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "261.146px",
    height: "294px",
    viewBox: "0 0 261.146 294",
    enableBackground: "new 0 0 261.146 294",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrinciples, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/principles.35c53642.svg";
export { ForwardRef as ReactComponent };